// extracted by mini-css-extract-plugin
export default {"external":"atlcRQ","tag":"btlcRQ","text":"ctlcRQ","block":"dtlcRQ"};